import type { ChunkFetchPriority } from './chunk-fetcher';

export const PLAYBACK_STATS_HISTORY = 20;

export type PlaybackFetchStat = {
  readonly latencyMs: number;
  readonly cacheHit: boolean;
  readonly resolved: boolean;
  readonly priority: ChunkFetchPriority;
};

export type PlaybackBoundaryStat = {
  readonly gapMs: number;
  readonly lookaheadDepth: number | null;
};

export type PlaybackSessionStats = {
  readonly sessionId: number;
  readonly fetches: readonly PlaybackFetchStat[];
  readonly boundaries: readonly PlaybackBoundaryStat[];
  readonly recoveryReasons: readonly string[];
};

export const emptyPlaybackSessionStats: PlaybackSessionStats = {
  sessionId: 0,
  fetches: [],
  boundaries: [],
  recoveryReasons: [],
};

export const resetPlaybackSessionStats = (stats: PlaybackSessionStats) => ({
  ...emptyPlaybackSessionStats,
  sessionId: stats.sessionId + 1,
});

const bounded = <Value>(values: readonly Value[], value: Value) =>
  [...values, value].slice(-PLAYBACK_STATS_HISTORY);

export const recordFetch =
  (stat: PlaybackFetchStat) => (stats: PlaybackSessionStats) => ({
    ...stats,
    fetches: bounded(stats.fetches, stat),
  });

export const recordBoundary =
  (stat: PlaybackBoundaryStat) => (stats: PlaybackSessionStats) => ({
    ...stats,
    boundaries: bounded(stats.boundaries, stat),
  });

export const recordRecovery =
  (reason: string) => (stats: PlaybackSessionStats) => ({
    ...stats,
    recoveryReasons: bounded(stats.recoveryReasons, reason),
  });
